import React from "react";

export const CoffeIcon = (props: {
  size?: number | string;
  width?: number | string;
  height?: number | string;
}) => {
  const { size = 20, width, height } = props;

  return (
    <svg
      viewBox="0 0 250 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63 134H154C154.515 134 155.017 133.944 155.5 133.839C155.983 133.944 156.485 134 157 134H209C212.866 134 216 130.866 216 127C216 123.134 212.866 120 209 120H203C199.134 120 196 116.866 196 113C196 109.134 199.134 106 203 106H222C225.866 106 229 102.866 229 99C229 95.134 225.866 92 222 92H200C203.866 92 207 88.866 207 85C207 81.134 203.866 78 200 78H136C139.866 78 143 74.866 143 71C143 67.134 139.866 64 136 64H79C75.134 64 72 67.134 72 71C72 74.866 75.134 78 79 78H39C35.134 78 32 81.134 32 85C32 88.866 35.134 92 39 92H64C67.866 92 71 95.134 71 99C71 102.866 67.866 106 64 106H24C20.134 106 17 109.134 17 113C17 116.866 20.134 120 24 120H63C59.134 120 56 123.134 56 127C56 130.866 59.134 134 63 134ZM226 134C229.866 134 233 130.866 233 127C233 123.134 229.866 120 226 120C222.134 120 219 123.134 219 127C219 130.866 222.134 134 226 134Z"
        fill="#F2F4F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.942 133.192L101.432 133.141V154.14C101.432 154.615 101.819 155 102.296 155H154.136C154.613 155 155 154.615 155 154.14V82.155C155 80.4126 153.582 79 151.832 79H104.6C102.85 79 101.432 80.4126 101.432 82.155V97.1227L99.942 97.0711C99.767 97.065 99.5917 97.062 99.416 97.062C90.3809 97.062 83 105.124 83 115.132C83 125.139 90.3809 133.202 99.416 133.202C99.5917 133.202 99.767 133.199 99.942 133.192ZM100.107 126.29C99.8778 126.309 99.6473 126.318 99.416 126.318C93.9625 126.318 89.6432 121.263 89.6432 115.132C89.6432 109.001 93.9625 103.946 99.416 103.946C99.6473 103.946 99.8778 103.955 100.107 103.973L101.432 104.079V126.184L100.107 126.29Z"
        fill="white"
        stroke="#98A2B3"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M147 85.1816V103.5M147 109.182V113.925V109.182Z"
        stroke="#D0D5DD"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M67.1289 147H74.001M181.129 147H184.001M161.001 147H176.429M80.001 147H97.4551"
        stroke="#98A2B3"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128 35C125.333 39.2135 124 42.8802 124 46C124 51.5562 128.654 54.0444 128.654 60.063C128.654 63.1177 127.103 66.1507 124 69.1621"
        stroke="#D0D5DD"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M115.999 46C115.127 51.5127 118.999 52.5322 118.999 57.4746C118.999 59.9831 117.999 62.4915 115.999 65"
        stroke="#D0D5DD"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M134.795 43.4741C133.473 46.8933 134.216 48.9774 134.795 50.2041C136.032 52.8262 137.999 55.0896 137.999 57.7578C137.999 60.8568 136.931 63.8392 134.795 66.7051"
        stroke="#D0D5DD"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M105 84C105 83.4477 105.448 83 106 83L125 83V152H106C105.448 152 105 151.552 105 151V84Z"
        fill="#F2F4F7"
      />
    </svg>
  );
};
